import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center gap-2", {
      'flex-col': $props.vertical
    }])
  }, [_createVNode(_component_Button, {
    size: "xs",
    variant: "default",
    icon: $props.vertical ? 'icon-chevron-up' : 'icon-chevron-left',
    onClick: _cache[0] || (_cache[0] = $event => this.HandleSelector($props.vertical ? 1 : -1))
  }, null, 8, ["icon"]), _createElementVNode("p", null, _toDisplayString($options.NormalizeValue), 1), _createVNode(_component_Button, {
    size: "xs",
    variant: "default",
    icon: $props.vertical ? 'icon-chevron-down' : 'icon-chevron-right',
    onClick: _cache[1] || (_cache[1] = $event => this.HandleSelector($props.vertical ? -1 : 1))
  }, null, 8, ["icon"])], 2);
}